const messages = {
  title: "Todo sobre BRIDGESTONE",
  description:
    "Tu valor añadido con Bridgestone - Este es el lema de nuestro programa, diseñado especialmente para nuestros socios comerciales. Accede a beneficios exclusivos pensados para impulsar tu negocio.",
};

export default {
  messages,
};
